import { render, staticRenderFns } from "./updateGroup.vue?vue&type=template&id=86bee628&scoped=true"
import script from "./updateGroup.vue?vue&type=script&lang=js"
export * from "./updateGroup.vue?vue&type=script&lang=js"
import style0 from "./updateGroup.vue?vue&type=style&index=0&id=86bee628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bee628",
  null
  
)

export default component.exports